export const ADMIN_APPLICATION_MGMNT_TEXT = 'Application Management';
export const ADMIN_APPLICATION_DETAIL_TEXT = 'Application';
export const ADMIN_NEW_APPLICATION_TEXT = 'New Application';

export const COLUMN_ALERT_MGMNT_TEXT = 'Column Alert Configuration';
export const CONFIGURATION_AUDIT_HISTORY_SEARCH = 'Config Audit History Search';

export const COLUMN_ALERT_MGMNT_DETAIL_TEXT = 'Column Alert';
